import styles from './index.module.scss';

export default function Loading() {
  return <div className={styles.ldsDualRing}></div>
}